import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';
import { getDeviceReport, exportDeviceReportCSV } from '../../../axios/Report/ReportUrlApi';
import { ReportPageHeader } from './ReportSharedComponents';

const DeviceReport = (props) => {
    const { onBack, setLoading, handleFilter, dataFilter, page, pageSize, getTabName, resetTableData, profile, isAdmin, totalPages } = props;
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language;

    const initialFormData = {
        sumBy: "1",
        startDate: new Date(),
        endDate: new Date(),
        showTime: "h-m-s",
        groupByDevices: false,
        showEvents: false,
        showEventsRadio: "first-and-last"
    }

    const [formData, setFormData] = useState(initialFormData)

    const bodyRequest = {
        "userId": isAdmin ? null : profile.userId,
        "groupId": dataFilter?.userGroup ? dataFilter.userGroup : null,
        "pageNo": page + 1,
        "recordPerPage": pageSize,
        "showTime": formData.showTime,
        "lang": currentLang
    }

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await getDeviceReport(bodyRequest);
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
                handleFilter({
                    ...response.data, pagination: {
                        ...response.data.pagination,
                        currentPage: response.data.pagination.currentPage - 1
                    }
                });
                setLoading(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (page || pageSize) {
            fetchData();
        }
    }, [page, pageSize]);


    useEffect(() => {
        getTabName("DeviceReport")
    }, []);

    function getCurrentTimestamp() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const HH = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');

        return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
    }

    const exportCSV = async () => {
        const payload = {
            ...bodyRequest,
            pageNo: totalPages
        }
        try {
            setLoading(true);
            const response = await exportDeviceReportCSV(payload);

            if (response) {
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                const filename = `${t("export.DeviceReport")}_${getCurrentTimestamp()}.xlsx`;

                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className='total-work-hours-report'>
            <ReportPageHeader
                onBack={onBack}
                titleKey="common.devices-report"
                onExport={exportCSV}
                startDate={formData.startDate}
                endDate={formData.endDate}
                onUpdateSuccess={fetchData}
            />
        </div>
    )
}

export default DeviceReport
